import { faFile, faFileEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAllVersions } from "actions/scriptActions";
import useToaster from "actions/useToaster";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Script } from "reducers/scriptReducer";

const ScriptVersioningPopup = ({ script, onClose, onConfirm }) => {
    const toaster = useToaster();
    const [versions, setVersions] = useState<Script[]>([]);
    useEffect(() => {
        getVersions();
    }, []);
    function getVersions() {
        getAllVersions(script.name)
            .then(res => setVersions(res))
            .catch(err => {
                toaster.error('Error retrieving script versions');
            });
    }
    return (
        <Modal show>
            <Modal.Header>
                <Modal.Title>&quot;{script.name}&quot; versions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="current-version-header">
                    <div className="versioning-version"><strong>{`Version`}</strong></div>
                    <div className="versioning-date"><strong>{`Timestamp`}</strong></div>
                    <div className="versioning-comment"><strong>{`Comment`}</strong></div>
                </div>
                <div className="list-container">
                    <div className="scroll-list">
                        <table className="queue-table" style={{ margin:"0" }}>
                            <thead style={{ width:"100%" }}>
                                <tr className="current-version-row">
                                    <th className="versioning-version" style={{ paddingBottom:"0", border:"0" }}/>
                                    <th className="versioning-date" style={{ paddingBottom:"0", border:"0" }}/>
                                    <th className="versioning-comment" style={{ paddingBottom:"0", border:"0" }}/>
                                    <th className="hover-icon-col" style={{ paddingBottom:"0" , border:"0" }}/>
                                </tr>
                            </thead>
                            <tbody>
                                {versions.map(version => {
                                    return (
                                        <tr className={"entry-row" + ((script.version === version.version) ? " active-version":"")}
                                            key={`entry-row-${version.name}-${version.version}}`}>
                                            <td>{`${version.version}`}</td>
                                            <td>{formatHumanReadable(version.timestamp?.toString())}</td>
                                            <td style={{ opacity:(version.comment ?"1":"0.5") }}>{`${(version.comment ? version.comment : "No comment")}`}</td>
                                            <td title="Open" style={{ paddingLeft:"0" }}>
                                                <FontAwesomeIcon
                                                    icon={faFileEdit}
                                                    className="clickable-icon hover-icon"
                                                    onClick={() => onConfirm(version)}
                                                />
                                            </td>
                                        </tr>)
                                })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
                        Cancel
                    </Button>
                </div>
            </Modal.Body>
        </Modal>);
};

function formatHumanReadable(timestamp: string | undefined) {
    if (timestamp !== undefined) {
        return format(new Date(timestamp), "dd/MM/yyyy HH:mm:ss");
    } else {
        return "";
    }
}

export default ScriptVersioningPopup;